<template>
  <q-page class="flex justify-center items-center">
    <div class="bg-blue-9 absolute-top-left full-height" style="width:calc(60vw);"></div>
    <q-card class="shadow-24" style="width:calc(100vw - 60px);height:calc(100vh - 60px);border-radius:20px;">
      <q-card-section horizontal>
        <q-card-section
          style="width:calc(60vw - 30px);height:calc(100vh - 60px)" class="bg-blue-7"
        >
          <q-scroll-area class="full-height full-width">
            <q-tab-panels :transition-duration="300" v-model="tab" animated class="bg-blue-7">
              <q-tab-panel name="login" class="bg-blue-7 text-center q-mt-lg" dark>
                <q-img src="formdata-logo-calig.svg" no-spinner style="width:80px;" class="q-my-lg"></q-img>
                <template v-if="invitation" >
                  <div class="text-subtitle1 text-white">Welcome back!</div>
                  <div class="text-h5 text-yellow" >You have been invited to collaborate</div>
                  <div class="text-white text-h6">Sign in to join the workspace</div>
                </template>
                <div v-else class="text-h4 text-white">Welcome back!</div>
                <q-img src="login.svg" no-spinner style="width:300px;max-width:35vh;" class="q-my-lg"></q-img>
                <div class="text-body1 text-white items-center">
                  Don't have an account yet?
                  <q-btn
                    outline no-caps
                    label="Sign up"
                    class="text-body1 text-bold q-ml-md"
                    @click="tab='register'"
                    id="login-to-register"
                  ></q-btn>
                </div>
              </q-tab-panel>

              <q-tab-panel name="register" class="bg-blue-7 text-center q-mt-lg" dark>
                <q-img src="formdata-logo-calig.svg" no-spinner style="width:80px;" class="q-my-lg"></q-img>
                <template v-if="invitation" >
                  <div class="text-subtitle1 text-white">Nice to meet you</div>
                  <div class="text-h5 text-yellow" >You have been invited to collaborate</div>
                  <div class="text-white text-h6">Sign up to join the workspace</div>
                </template>
                <div v-else class="text-h4 text-white">Nice to meet you</div>

                <q-img src="signup.svg" no-spinner style="width:300px;max-width:40vh;" class="q-my-lg"></q-img>
                <div class="text-body1 text-white items-center">
                  Already have an account?
                  <q-btn
                    outline no-caps
                    label="Sign in"
                    class="text-body1 text-bold q-ml-md"
                    @click="tab='login'"
                    id="register-to-login"
                  ></q-btn>
                </div>
              </q-tab-panel>
            </q-tab-panels>
          </q-scroll-area>
        </q-card-section>
        <q-card-section style="width:calc(40vw - 30px)">
          <q-scroll-area class="full-height full-width">
            <q-tab-panels :transition-duration="350" v-model="tab" animated>
              <q-tab-panel name="login" class="q-pa-none">
                <AuthComponent :tab="tab" />
              </q-tab-panel>

              <q-tab-panel name="register" class="q-pa-none">
                <AuthComponent :tab="tab"/>
                <div class="q-ma-sm">
                  <b>Note:</b> By signing up you agree to our <a href="https://form-data.com/pages/legal/terms-of-use" target="_blank">terms of use</a> and
                  <a href="https://form-data.com/pages/legal/privacy-policy" target="_blank">privacy policy</a>
                </div>
              </q-tab-panel>
            </q-tab-panels>
          </q-scroll-area>
        </q-card-section>
      </q-card-section>
    </q-card>
  </q-page>
</template>

<script>
import AuthComponent from "components/AuthComponent";
import { defineComponent, ref, computed } from 'vue';
import {useInvitationStore} from "stores/invitation";


export default defineComponent({
  name: 'AuthPage',
  components: { AuthComponent },
  props: {
    mode: {
      type: String,
      default: 'login'
    },
    inv: {
      type: String,
      default: null
    }
  },
  setup (props) {
    const tab = ref(props.mode === 'login' ? 'login' : 'register');
    const invitationStore = useInvitationStore()
    // invitationStore.init(props.inv)
    const invitation = computed(() => invitationStore.invitationToken)


    return {
      tab,
      invitation
    }
  }
});
</script>
